//let appViewLoaded: boolean = false; //Global to handle the viewContentLoaded value...needs to be here (for some reason)
var ApprovalsController = (function () {
    function ApprovalsController(env, $filter, DTS, $stateParams, $state, socket, $scope, config, $rootScope) {
        var _this = this;
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.config = config;
        this.$rootScope = $rootScope;
        this.results = []; //declare the 'scoped' field to be displayed
        this.resultsRetrieved = false;
        this.table = { sortType: 'bp', sortReverse: false, search: '', filter: false, filterParams: {} };
        this.stages = null;
        this.toggleStages = false; //show hide approvers stages
        //Listener below...if a socket.emit for approvals.list is made...
        this.socket.forward('approvals.list', this.$scope);
        this.$scope.$on('socket:approvals.list', function (event, data) {
            _this.displayResults(event, data); //...take the results (data) and send to function to display
            _this.setDetails();
        });
        //Do this to prevent the onInit() firing twice on a page refresh
        //      this.$rootScope.$on('$viewContentLoaded', (event, toState, toParams, fromState, fromParams) => {
        //        appViewLoaded = true;
        //    });
        //  console.log(this.$state);
    }
    ApprovalsController.prototype.resetFilters = function () {
        this.table.filters = '';
        this.table.filterParams = {};
    };
    //This will run as soon as the page loads...will hit the /approvals url and
    //send the user's email address taken from the 'env' - the object containing the user info
    ApprovalsController.prototype.$onInit = function () {
        //Only fire the socket call if the view content is loaded (see constructor)
        //  if (appViewLoaded) {
        //Set table headers
        this.table.headers =
            [{
                    'Opp': 'opp', 'BP Name': 'bp', 'Country': 'country', 'Account Name': 'acnt',
                    'Status': 'status', 'Sub Status': 'substatus', 'Owner': 'owner'
                }];
        this.fireSocket();
        //}
    };
    ApprovalsController.prototype.fireSocket = function () {
        this.resultsRetrieved = false; //Wipe
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                currentUser: this.env.user,
                user: this.env.user,
                function: 'getAwaitingApprovalByUser',
                script: '/approvals/approvals'
            }
        });
    };
    ApprovalsController.prototype.setDetails = function () {
        //Anyone who is not an approver or Administrator shouldn't even be able to get into this page
        this.appRole = this.env.getRoleAsString();
        //let bpsononbpso = this.bpsoNonBpso === this.env.user.access.nonBpsoApprover ? 'Non-BPSO' : 'BPSO';
        var bpsononbpso = this.env.user.access.nonBpsoApprover || this.env.user.access.nonBpsoAdmin ? 'Non-BPSO' : 'BPSO';
        if (this.env.user.access.bpsoAdmin || this.env.user.access.nonBpsoAdmin) {
            this.bpsoNonBpso = bpsononbpso + ' Peer/Colleague';
            this.stages = this.config.getAppStagesForApprover(this.env.user.email, bpsononbpso);
        }
        else {
            this.bpsoNonBpso = bpsononbpso + ' Management/Team Leader';
            this.stages = this.config.getAppStagesForApprover(this.env.user.email, null);
        }
        //this.stages = this.config.getAppStagesForApprover('pavolpipiska@sk.ibm.com', null);
    };
    ApprovalsController.prototype.displayResults = function (event, data) {
        this.results = data; //Update class field
        this.resultsRetrieved = true;
    };
    ApprovalsController.prototype.getAvatar = function (email) {
        return this.DTS.getAvatar(email, 115);
    };
    ApprovalsController.$inject = ['env', '$filter', 'DTS', '$stateParams', '$state', 'socket', '$scope', 'config', '$rootScope'];
    return ApprovalsController;
}());
var ApprovalsComponent = (function () {
    function ApprovalsComponent() {
        this.templateUrl = 'approvals.html';
        this.controllerAs = 'vm';
        this.controller = ApprovalsController;
    }
    return ApprovalsComponent;
}());
angular
    .module('application')
    .component('approvalsSection', new ApprovalsComponent());

//# sourceMappingURL=approvals.component.js.map
